import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { PROMO_FEATURE_FLAG, shouldShowPromotion } from '@mc/promo-utils'
import { useStaticData } from '@mc/static-data-react'
import { trackExperimentViewed } from '@mc/track-event'
import { MC_PRO_PROMO_FLAG_NAME, type MCProPromoBucket } from '../constants'

// Only the Plans Page passes `trackExposure`, so exposure fires once per view.
// It is never gated on the bucket, or control stops enrolling with the variants.
export const useMCProPromoExperiment = ({ trackExposure = false } = {}) => {
  const { isGift } = useStaticData<{ isGift: boolean }>()
  const ownBucket = useBucket<MCProPromoBucket>(MC_PRO_PROMO_FLAG_NAME)
  const { isPromotionOn } = shouldShowPromotion({
    promoBucket: useBucket(PROMO_FEATURE_FLAG),
  })
  const shouldTrackExposure = trackExposure && !isGift

  useEffect(() => {
    if (shouldTrackExposure) trackExperimentViewed(MC_PRO_PROMO_FLAG_NAME)
  }, [shouldTrackExposure])

  const bucket = isGift ? undefined : ownBucket
  const isVariant1 = bucket === 'variant_1'
  const isVariant2 = bucket === 'variant_2'

  return {
    bucket,
    isInMCProPromoVariant: isPromotionOn && (isVariant1 || isVariant2),
    isVariant1,
    isVariant2,
  }
}
